import { render, staticRenderFns } from "./snb-profile.vue?vue&type=template&id=a1095b4a&scoped=true&"
import script from "./snb-profile.vue?vue&type=script&lang=tsx&"
export * from "./snb-profile.vue?vue&type=script&lang=tsx&"
import style0 from "./snb-profile.vue?vue&type=style&index=0&id=a1095b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1095b4a",
  null
  
)

export default component.exports